import moment from 'moment'
import StringUtil from '@/utils/StringUtil'
import numUtil from '@/utils/NumberUtil'
import dayjs from 'dayjs'
import ArrayUtil from '@/utils/ArrayUtil'

/**
 * 字符串截取
 *  2019-08-14 00:00:00 -> 2019-08-14
 * @param dt
 * @returns {string}
 */
export function dt2day(dt) {
    return dt.substring(0, 10);
}

/**
 * 将时间戳转换成 yyyy-MM-dd hh:mm:ss
 * @param longTime  毫秒
 */
export function timestampToMdhms(longTime) {
    return moment(longTime).format('YYYY-MM-DD HH:mm:ss')
}

export function dateFormat(date, fmt = 'YYYY-MM-DD') {
    if(date === null || date === ''){
        return ""
    }
    return dayjs(date).format(fmt)
}

export function dateTimeFormat(date, fmt = 'YYYY-MM-DD HH:mm:ss') {
    if(date === null || date === ''){
        return ""
    }
    return dayjs(date).format(fmt)
}

export function iosRewardFormat(list) {
    return ArrayUtil.iosRewardTranslate(list)
}

/**
 * 翻译布尔类型
 * @param flag
 * @returns {string}
 */
export function boole(flag) {
    var result = "否";
    if (flag === true) {
        result = "是";
    }
    return result;
}

/**
 * 翻译是否类型
 * @param flag
 * @returns {string}
 */
export function yesOrNo(flag) {
    var result = "否";
    if (flag === 1) {
        result = "是";
    }
    return result;
}

/**
 * 将v翻译成对应的名称, 带对应的key
 * @param v  相当于trans里的key
 * @param trans 对象 {a:10, b:20, c:30}
 * @returns {string} 返回对应的翻译后内容
 */
export function commonFilter(v, trans) {
    if (v in trans) {
        return `${v}-${trans[v]}`
    }
    return `${v}-未知`
}

export function iosFilter(v, trans) {
    if (v in trans) {
        return `${trans[v]}`
    }
    return `未知`
}

export function commonFilter1(v, trans, msg = '') {
    if (!trans) {
        return v
    }
    if (v in trans) {
        return `${v}--${trans[v]}`
    }
    if (msg !== '') {
        return `${v}--${msg}`
    }
    return v
}


/**
 * 将v翻译成对应的名称，不带对应key
 * @param v  相当于trans里的key
 * @param trans 对象 {a:10, b:20, c:30}
 * @returns {string} 返回对应的翻译后内容
 */
export function commonFilterWithNoKey(v, trans) {
    if (!trans) {
        return v
    }
    if (v in trans) {
        if (trans[v] === '' || trans[v] === null ){
            return v
        }
        return trans[v]
    }
    return v
}

/**
 * 保留，小数并换成百分数，不加%
 * @param num
 * @param figuresKeep 保留位数, 默认两位
 * @returns {*}
 */
export function keepFigures(num, figuresKeep = 2) {
    if (num === -1) return '--';
    return numUtil.toPercentWithFigures(num, figuresKeep, false)
}

/**
 * 保留，小数并换成百分数，加%
 * @param num
 * @param figuresKeep 保留位数, 默认两位
 * @returns {*}
 */
export function keepFiguresPercent(num, figuresKeep = 2) {
    if (num === -1) return '--';
    return numUtil.toPercentWithFigures(num, figuresKeep, true)
}

export function percentOnly(num) {
    if (num <= 0) return num;
    return num + '%'
}

/**
 * 只对小数位处理， 默认2位
 * @param num
 * @param figuresKeep
 * @returns {*}
 */
export function keepFiguresOnly(num, figuresKeep = 2) {
    if (num === -1) return '--';
    return numUtil.keepFigures(num, figuresKeep)
}

/**
 * 千分位显示小数
 * @param num
 * @returns {string}
 */
export  function thousandthOnly(num) {
    if(num !== 0 && !num) {
        return ''
    }
    num = numUtil.keepFigures(num, 2);
    if(num === 0){
        return 0
    }
    num += ''
    if (!num.includes('.')) num += '.';
    return num.replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {
        return $1 + ',';
    }).replace(/\.$/, '');
}

/**
 * 将数字翻译成星期
 * @param v
 * @returns {*}
 */
export function dayOfWeek(v) {
    switch (v) {
        case 1:
            return '星期日';
        case 2:
            return '星期一';
        case 3:
            return '星期二';
        case 4:
            return '星期三';
        case 5:
            return '星期四';
        case 6:
            return '星期五';
        case 7:
            return '星期六';
        default:
            return v
    }

}


/**
 * 省份过虑
 * @param v   1,2,3,4,5
 * @param trans
 * @returns {*}
 */
export function provincesFilter(v, trans) {
    if (v === '' || !v) {
        return v
    }
    const arr = StringUtil.stringToArrayWithSep(v);
    const newArr = [];
    arr.forEach((item) => {
        if ({}.hasOwnProperty.call(trans, item)) {
            newArr.push(trans[item])
        } else {
            newArr.push(item)
        }
    });
    return newArr
}